import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import modalScrollBar from "../ModalScrollBar/ModalScrollBar";

import "./Spinner.less";

class Spinner extends React.Component {
  render() {
    return (
      <Modal
        isOpen={this.props.showSpinner}
        className="modal-md modalContainer spinner"
        xs="8"
        centered={true}
        style={{ background: "transparent" }}
      >
        <ModalBody>
          {" "}
          <div className="loader"></div>{" "}
        </ModalBody>
      </Modal>
    );
  }
}

Spinner.propTypes = {
  aString: PropTypes.string,
  anObject: PropTypes.object,
  aFunc: PropTypes.func,
  aBool: PropTypes.bool,
  anArray: PropTypes.array
};

export default modalScrollBar(Spinner);
